import React from "react";

export const LinkedInLogo = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.37402 8.85518H13.0728V10.2812C13.214 10.2812 13.327 10.2812 13.3552 10.2812C13.99 9.49895 14.8537 8.93969 15.8224 8.68354C16.7911 8.42738 17.8153 8.48746 18.7481 8.85518C19.4649 9.03939 20.1059 9.44728 20.5799 10.0208C21.0539 10.5943 21.3367 11.3042 21.3881 12.0495C21.5454 13.47 21.6255 14.8982 21.6281 16.3276C21.6281 18.0816 21.6281 19.8356 21.6281 21.6466H17.6893C17.6893 19.8213 17.6893 17.9817 17.6893 16.1564C17.6943 15.3409 17.6424 14.5261 17.534 13.7179C17.5379 13.489 17.4959 13.2617 17.4105 13.0497C17.3252 12.8376 17.1982 12.6452 17.0373 12.484C16.8764 12.3228 16.6849 12.1961 16.4742 12.1117C16.2636 12.0272 16.0382 11.9866 15.8117 11.9924C15.3206 11.8911 14.8097 11.982 14.3825 12.2468C13.9553 12.5115 13.6436 12.9303 13.5105 13.4185C13.3526 14.0865 13.2721 14.7708 13.2705 15.4577C13.2705 17.4541 13.2705 19.4505 13.2705 21.5183H9.37402V8.85518Z"
        fill="#ECEFF2"
      />
      <path
        d="M2.93652 8.8418H6.77652V21.5619H2.93652V8.8418Z"
        fill="#ECEFF2"
      />
      <path
        d="M7.05836 4.73616C7.08305 5.05192 7.04279 5.36942 6.94012 5.6687C6.83745 5.96798 6.67459 6.24256 6.46177 6.47518C6.24895 6.7078 5.99078 6.89342 5.7035 7.02037C5.41622 7.14733 5.10604 7.21286 4.79247 7.21286C4.4789 7.21286 4.16872 7.14733 3.88144 7.02037C3.59416 6.89342 3.33599 6.7078 3.12318 6.47518C2.91036 6.24256 2.74749 5.96798 2.64482 5.6687C2.54215 5.36942 2.5019 5.05192 2.52659 4.73616C2.51795 4.41997 2.57491 4.10545 2.6938 3.81282C2.81268 3.52019 2.99087 3.25593 3.2169 3.03701C3.44294 2.81809 3.71182 2.64937 4.00626 2.54169C4.30071 2.434 4.6142 2.38974 4.92659 2.41174C5.5133 2.43771 6.0662 2.69634 6.4653 3.13151C6.8644 3.56668 7.0775 4.14328 7.05836 4.73616Z"
        fill="#ECEFF2"
      />
    </svg>
  );
};
